import { CaptchaSendType, UserAuthorizationType } from '@next-space/fe-api-idl';
import { useCallback } from 'react';
import { appI18n } from '@flowus/common/i18n';

import { loginInjector } from '../utils/init';

/**绑定已有的账号 */
export const useBindAccount = () => {
  const bindEmail = useCallback(async (userId: string, email: string, captcha: string) => {
    const res = await loginInjector.request.infra.emailAuthorization({
      email,
      captcha,
      type: CaptchaSendType.BIND_NEW,
    });
    if (res.nickname) {
      loginInjector.message.success(
        appI18n.t('pkg_login.account_bound_by_nickname', { nickname: res.nickname }) as string
      );
      return;
    }
    return loginInjector.request.infra.bindThirdAccount(userId, {
      type: UserAuthorizationType.EMAIL,
      code: res.authorizationCode ?? '',
    });
  }, []);

  const bindWechat = useCallback(async (userId: string, code: string) => {
    const res = await loginInjector.request.infra.wechatAuthorization({
      code,
      type: 'web',
    });
    return loginInjector.request.infra.bindThirdAccount.raw(userId, {
      type: UserAuthorizationType.WECHAT,
      code: res.authorizationCode ?? '',
    });
  }, []);
  return {
    bindEmail,
    bindWechat,
  };
};
